import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, inject } from '@angular/core';
import { FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash-es';
import { AlertService } from 'src/app/services/alert.service';
import { LoaderService } from 'src/app/services/loader.service';
import { IUser, User, USER_LANGUAGES } from 'src/app/models/users.model';
import { FormGroupComponent } from 'src/app/shared/pages/form-group/form-group.component';
import { Group, IGroup } from 'src/app/models/groups.model';
import { MatAutocompleteSelectedEvent as MatAutocompleteSelectedEvent, MatOption } from '@angular/material/autocomplete';
import { MatChipInputEvent as MatChipInputEvent } from '@angular/material/chips';
import { ENTER, COMMA } from '@angular/cdk/keycodes';

import { TITLESPAGES } from 'src/app/models/titlePage.model';
import { Title } from '@angular/platform-browser';
import { AuthService } from 'src/app/services/auth.service';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { KeyValuePipe } from '@angular/common';

// @ts-ignore
// const api = require('@modules/cf-api.js').api;;
// const api_async = require('@modules/cf-api.js').api_async;

@Component({
    selector: 'app-my-account-info',
    templateUrl: './my-account-info.component.html',
    styleUrls: ['./my-account-info.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule, RxReactiveFormsModule, MatFormField, MatLabel, MatInput, MatSelect, MatOption, KeyValuePipe, TranslatePipe]
})

export class MyAccountInfoComponent extends FormGroupComponent<IUser> implements OnInit {
    protected cd = inject(ChangeDetectorRef);
    protected dialog = inject(MatDialog);
    private fb = inject(FormBuilder);
    protected titleService = inject(Title);
    protected translate = inject(TranslateService);

    separatorKeysCodes: number[] = [ENTER, COMMA];

    groupFilter: FormControl = new FormControl('');

    groups: Group[] = [];
    get filteredGroups(): Group[] { return this.groups.filter(g => this.onFilter(g) && !this.controls.groups.value.includes(g._id)); };

    USER_LANGUAGES = USER_LANGUAGES;

    constructor() {
        super();

        this.titleService.setTitle(TITLESPAGES.ACCOUNT_TITLE);
    }

    override initForm() {
        this.form = this.fb.group({
            username: new FormControl('', [Validators.required]),
            firstName: new FormControl('', [Validators.required]),
            lastName: new FormControl('', [Validators.required]),
            email: new FormControl('', [Validators.email, Validators.required]),
            customer: new FormControl({ value: '', disabled: !this.creating }, [Validators.required]),
            groups: new FormControl([]),
            language: new FormControl('fr', [Validators.required]),
        });
    }

    async initSubscriptions(): Promise<void> {
        // this.subscription.add(this.modelChange.subscribe(this.patch.bind(this)));
        this.model = this.currentUser || new User({});
    }

    //#region groups
    // resetGroups(){
    //     this.controls.groups.setValue();
    // }

    onFilter(group: IGroup) {
        let value = this.groupFilter.value?.toLowerCase();
        if (value) {
            return group.name.toLowerCase().includes(value);
        }
        else {
            return true;
        }
    }

    removeGroup(id: string) {
        let index = (this.controls.groups.value as string[]).findIndex(v => v === id);
        if (index >= 0) {
            (this.controls.groups.value as string[]).splice(index, 1);
        }
    }

    addGroup(event: MatAutocompleteSelectedEvent) {
        let id = event.option.value;
        this.controls.groups.patchValue(_.concat(this.controls.groups.value as string[], [id]));
        this.groupFilter.reset();
    }

    add(event: MatChipInputEvent): void {
        event.chipInput!.clear();
        this.groupFilter.reset();
    }

    getGroups(id: string) {
        return this.groups.find(g => g._id === id);
    }

    resetPassword() {
        if (this.currentUser?._id)
            this.router.navigate(['user/reset-password/' + this.currentUser._id + '/0']);
    }
}
